module.exports = __webpack_public_path__ + "img/to_podosinki.41740b63.jpg";